import React from 'react'

import Nav from '../Nav/Nav'
import { LeadTypes } from '../../includes/leadConstants'

import AddressLeadForm from './AddressLeadForm/AddressLeadForm'
import Header from './Header/Header'

import './HomeScene.css'

const HomeScene = () => (
  <div className="HomeScene">
    <Nav slim={true} />
    <div className="container">
      <div className="row align-items-center justify-content-center hero">
        <div className="col HomeScene__Overlay">
          <Header />
          <AddressLeadForm
            campaign="address_search"
            lead_type={LeadTypes.EMAIL_ONLY}
            tenant_id={process.env.REACT_APP_TENANT_ID}
            year={process.env.REACT_APP_ACTIVE_ELECTION_YEARS.split(',')[0]}
          />
        </div>
      </div>
    </div>
  </div>
)

export default HomeScene



// WEBPACK FOOTER //
// ./src/components/HomeScene/HomeScene.js